export const GET_AUDIT_LOGS = gql`
    query auditLogs($entity: AuditLogEntity, $entityId: Int) {
        auditLogs(input: { entity: $entity, entityId: $entityId }) {
            id
            ipAddress
            event
            userId
            details
            entity
            entityId
            user {
                firstName
                lastName
                role {
                    name
                    id
                    hierarchyLevel
                }
            }
            createdAt
        }
    }
`;
